import React from 'react';

export const CardLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="container relative h-screen flex-col items-center justify-center grid lg:max-w-none lg:grid-cols-2 lg:px-0">
    {children}
  </div>
);
